import React, { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { useTranslation } from "react-i18next";
import UserRoles from "../../../Shared/Constant/UserRoles";

const NON_EDITABLE_FIELDS = [
  "districtId",
  "talukaId",
  "villageId",
  "phcId",
  "subcenterId",
  "roleId",
  "facultyId",
  "programId",
  "schemeId",
  "lgbId",
  "corporation_council_id",
  "areaId",
  "areaCategoryId",
];

const SelectDropdown = ({
  input,
  placeholder,
  options,
  label,
  asterisk,
  disabled,
  change,
  optionLabel,
  containsValues,
  meta: { touched, error },
  mode,
  roleName,
  masterType,
}) => {
  const { t } = useTranslation("master");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const getLabel = () => {
    if(masterType === 'userMaster'){
      if (input.name === "phcId" && roleName === UserRoles.PHCMO) {
        return "PHC Name";
      }else if (input.name === "phcId" && roleName === UserRoles.UPHCMO) {
        return "UPHC Name";
      }
    }
    return label;
  };

  const resetFields = (fields) => {
    fields.forEach((field) => {
      change(field, field.endsWith("Id") ? 0 : "");
    });
  };

  const handleChange = (e) => {
    const { value } = e.target;
    input.onChange(value);

    const selectedItem = options.find((option) => option.value === value);
    const selectedName = selectedItem?.label || "";
    change(optionLabel, selectedName);

    // Update dependent values
    if (containsValues?.length) {
      containsValues.forEach((item) => {
        const updatedValue = selectedItem[item.value] || item.initialValue;
        change(item.name, updatedValue);
      });
    }

    // Reset dependent fields based on input name
    const resetMappings = {
      districtId: ["talukaId", "talukaName", "phcId", "phcName", "lgbId", "lgbName"],
      talukaId: ["phcId", "phcName"],
      lgbId: ["talukaId", "talukaName", "phcId", "phcName"],
      roleId: [
        "districtId",
        "districtName",
        "talukaId",
        "talukaName",
        "phcId",
        "phcName",
        "lgbId",
        "lgbName",
      ],
    };

    if (masterType === "userMaster") {
      const areaFields = ["areaId", "areaType"];
      if (resetMappings[input.name]) {
        resetFields([...resetMappings[input.name], ...areaFields]);
      }
      if (input.name === "phcId") {
        change("areaId", selectedItem?.areaId || 0);
        change("areaType", selectedItem?.areaType || "");
      }
    } else if (resetMappings[input.name]) {
      resetFields(resetMappings[input.name]);
    }
  };

  const isDisabled = () => {
    if (mode === "Update") {
      return NON_EDITABLE_FIELDS.includes(input.name) && input.value !== "";
    }
    if (mode === "Add" && input.name === "areaId") {
      return ["UPHC MO", "PHC MO"].includes(roleName);
    }
    return false;
  };

  const handleFocus = () => setDropdownOpen(true);
  const handleBlur = () => {
    if (dropdownOpen) setDropdownOpen(false);
    else input.onBlur();
  };

  const disabledClass = isDisabled()
    ? "bg-gray-200 cursor-not-allowed border-gray-300"
    : "";

  return (
    <>
      <label className="input-label" htmlFor={input.name}>
        <span className="astoricstyle">{asterisk}</span>
        {t(getLabel())}
      </label>
      <Dropdown
        {...input}
        id={input.name}
        value={input.value}
        options={options}
        placeholder={placeholder}
        itemTemplate={ItemTemplate}
        valueTemplate={ValueTemplate}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={disabled || isDisabled()}
        filter
        className={`input-style ${touched && error ? "border-red-500" : ""} ${disabledClass}`}
        panelClass={dropdownOpen ? "dropdown-panel-open" : ""}
      />
      {touched && error && <span className="text-red-500">{error}</span>}
    </>
  );
};

export default SelectDropdown;

// Templates
function ItemTemplate(selectedItem) {
  return <span>{selectedItem.label}</span>;
}

function ValueTemplate(selectedItem) {
  return <span>{selectedItem?.label || "|"}</span>;
}
